import { DatePipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';
import { TimezoneService } from '../services/timezone.service';
import { AlcmeonContextService } from 'src/app/core/alcmeon-context/alcmeon-context.service';

/**
 * Overload DatePipe to add the time zone of the user.
 * Same parameters as DatePipe.
 */
@Pipe({
  name: 'dateTimezone',
})
export class DateTimezonePipe implements PipeTransform {
  constructor(
    private alcmeonContextService: AlcmeonContextService,
    private datePipe: DatePipe,
    private timezoneService: TimezoneService
  ) {}

  transform(
    value: Date | string | number | null | undefined,
    format?: string,
    timezone?: string,
    locale?: string
  ): string | null {
    if (!value) {
      return value as string;
    }

    if (typeof value === 'string') {
      if (value === 'N/A') {
        return value as string;
      }

      // '2023-12-15T15:42:56'
      if (value.match(/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}$/)) {
        value = `${value}Z`;
      }
      // '2023-12-15 15:42:56'
      else if (value.match(/^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}$/)) {
        value = `${value}Z`.replace(' ', 'T');
      }
    }

    const userTimezone = this.alcmeonContextService.self.timezone;
    const timezoneOffset = this.timezoneService.formatOffsetForTimezone(value as string, userTimezone);

    return this.datePipe.transform(value, format, timezoneOffset, locale);
  }
}
